import { MobilePopupBottom } from '@lt/components';
import React from 'react';
import type { LuggageItem } from 'src/components/Luggage/types';
import FlightsLuggageTooltip from '../../FlightsLuggageTooltip';

type Props = {
  luggageArray: LuggageItem[];
  setIsTooltipOpened: (value: boolean) => void;
  isTooltipOpened: boolean;
};

const FlightsLuggageTooltipMobile = ({
  luggageArray,
  setIsTooltipOpened,
  isTooltipOpened,
}: Props) => (
  <MobilePopupBottom
    onClick={() => setIsTooltipOpened(false)}
    visible={isTooltipOpened}
    options={{ showHandlebar: true }}
  >
    <FlightsLuggageTooltip luggage={luggageArray} hasTitle />
  </MobilePopupBottom>
);

export default FlightsLuggageTooltipMobile;
